import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "align-right flex items-center text-sm text-gray-500"
}
const _hoisted_2 = ["datetime"]

import { computed } from 'vue';
import { formatDateAsString } from '@/utils/datetime';
import { CalendarIcon } from '@heroicons/vue/solid';
import { Permission, CreatedAudit, UpdatedAudit } from '@/types';
import { useI18n } from 'vue-i18n';
import { RouterLink } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiAuditInfo',
  props: {
    modelValue: {},
    dateFormat: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const lastModifiedBy = computed(() => {
    return props.modelValue.updatedByUser || props.modelValue.createdByUser || null;
});

const lastModifiedAt = computed(() => {
    return props.modelValue.updatedAt || props.modelValue.createdAt || null;
});

const lastModifiedType = computed(() => {
    return props.modelValue.updatedByUser ? 'updatedAt' : 'createdAt';
});

// fallback to 'LL' if no dateFormat is provided
const resolvedDateFormat = computed(() => props.dateFormat || 'LL');

return (_ctx: any,_cache: any) => {
  return (lastModifiedBy.value && lastModifiedAt.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(CalendarIcon), {
          class: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
          "aria-hidden": "true"
        }),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_unref(t)(`core.${lastModifiedType.value}`)) + " ", 1),
          _createElementVNode("time", { datetime: lastModifiedAt.value }, _toDisplayString(_unref(formatDateAsString)(lastModifiedAt.value, resolvedDateFormat.value)), 9, _hoisted_2),
          _createTextVNode(" " + _toDisplayString(_unref(t)('core.by')) + " ", 1),
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$can(_unref(Permission).VIEW_USER) ? _unref(RouterLink) : 'span'), {
            to: { name: 'ViewUserById', params: { id: lastModifiedBy.value.id } },
            class: "text-primary truncate text-sm font-medium"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(lastModifiedBy.value.name), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})